var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"InputLabel"},[_c('label',{staticClass:"InputLabel__label",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }